<template>
  <v-container class="py-0 px-5">
    <v-row>
      <v-col
        v-if="document.element_type !== 'organization'"
        cols="12"
      >
        <data-selector
          v-model="document.document_type_id"
          autofocus
          field-name="document_type_id"
          source-type="documentTypes"
          :filter="document.element_type"
          translate
        />
      </v-col>
      <v-col
        v-if="document.element_type === 'organization'"
        cols="12"
      >
        <validated-text-field
          v-model="document.name"
          field-name="name"
          type="text"
        />
      </v-col>
      <v-col cols="12">
        <date-field
          v-model="document.issue_date"
          field-name="issue_date"
          rules="date"
        />
      </v-col>
      <v-col cols="12">
        <date-field
          v-model="document.expiration_date"
          field-name="expiration_date"
          rules="date"
        />
      </v-col>
      <v-col cols="4">
        <v-checkbox
          v-model="document.no_expiry"
          :label="$t('fields.no_expiry')"
        />
      </v-col>
    </v-row>
    <v-card-actions class="justify-center">
      <v-btn
        v-if="document.storage_id !== null"
        :href="documentStorageUrl"
        icon
        target="_blank"
      >
        <v-icon>
          {{ '$show' }}
        </v-icon>
      </v-btn>
      <validation-provider
        v-slot="{ errors }"
        name="storage_id"
      >
        <upload-files
          filter="document"
          source-type="document"
          :upload-params="document"
          class="mt-2"
          @success="uploaded"
        />
        <span style="color: red">{{ errors['0'] }}</span>
      </validation-provider>
    </v-card-actions>
    <v-row
      v-if="history.length > 0"
      class="pb-2"
    >
      <v-expansion-panels>
        <v-expansion-panel>
          <v-expansion-panel-header>
            {{ $t('document_history') }}
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-list dense>
              <template>
                <div v-for="(hist, i) in history" :key="i">
                  <v-divider />
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title v-text="hist" />
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-icon
                        color="grey lighten-1"
                        @click="show(hist)"
                      >
                        {{ '$show' }}
                      </v-icon>
                    </v-list-item-action>
                  </v-list-item>
                </div>
              </template>
            </v-list>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-row>
  </v-container>
</template>

<script>
  import { call } from 'vuex-pathify'

  export default {
    name: 'EditDocument',
    props: {
      document: Object,
      history: {
        type: Array,
        default: () => [],
      },
    },
    computed: {
      uploadParams () {
        return {
          element_type: this.document.element_type,
          element_id: this.document.element_id,
        }
      },
      documentStorageUrl () {
        // return 'data:image/jpeg;base64,' + this.user.avatar.image
        return process.env.VUE_APP_API_URL + '/api/storage/' + this.document.storage_id
      },
    },
    methods: {
      getDocument: call('exportData/document'),
      uploaded (response) {
        this.document.storage_id = response.id
        console.log(response.id)
      },
      show (version) {
        this.getDocument({
          id: this.document.id,
          version: version,
          sourceType: 'document',
          type: 'pdf',
        })
      },
    },
  }
</script>
